import React from 'react';
import { Theme } from '@mui/material';

import { WithStyles } from '@mui/styles';
import createStyles from '@mui/styles/createStyles';
import withStyles from '@mui/styles/withStyles';

import VisibilityManager from 'components/VisibilityManager';
import HeaderBar from 'components/HeaderBar';
import SideBar from 'components/SideBar';
import HomeRouter from './HomeRouter';
import { Routes } from 'routing';
import SetPageNavAction from 'components/Portals/SetPageNavAction';
import SetPageHeaderRightContent from 'components/Portals/SetPageHeaderRightContent';
import ViewStoreBtn from 'components/ViewStoreBtn';
import { useTranslation } from 'services/localization/useTranslation';
import AddOnModalManager from 'components/modals/AddOnModalManager';
import InstalledAddOnModalManager from 'components/modals/InstalledAddOnModalManager';
import { useHasFeature } from 'hooks';
import AccountDisabledModal from './components/AccountDisabledModal';
import EarnCreditsModal from './components/EarnCreditsModal';

type Props = WithStyles<typeof styles>;

const HomeContainer = ({ classes }: Props) => {
	const { t } = useTranslation();
	const { hasFeature } = useHasFeature();

	const quickLinks = (() => {
		const links = [];

		if (hasFeature('NEW_RENTAL')) {
			links.push({
				title: t('headerBar.createOrder', 'Create order'),
				to: Routes.NEW_RENTAL,
			});
		}

		links.push({
			title: t('headerBar.orders', 'Orders'),
			to: Routes.Bookings(),
		});

		return links;
	})();

	return (
		<div className={classes.root}>
			<AccountDisabledModal />
			<HeaderBar />
			<VisibilityManager />
			<div className={classes.main}>
				<HomeRouter />
			</div>
			<SideBar />
			{/** The default nav action, automatically overriden by page-specific actions where defined */}
			<SetPageNavAction priority={-1} quickLinks={quickLinks} />
			{/** The default header content, automatically overriden by page-specific content where defined */}
			<SetPageHeaderRightContent priority={-1}>
				<ViewStoreBtn />
			</SetPageHeaderRightContent>
			<AddOnModalManager />
			<InstalledAddOnModalManager />
			<EarnCreditsModal />
		</div>
	);
};

const styles = (theme: Theme) =>
	createStyles({
		root: {
			display: 'flex',
			flexDirection: 'column',
			background: theme.palette.background.default,
			minHeight: '100%',
		},
		header: {
			width: '100%',
			flex: '0 0 auto',
		},
		main: {
			flex: '1 1 auto',
			flexDirection: 'column',
			display: 'flex',
			width: '100%',
			'-webkit-overflow-scrolling': 'touch',
		},
	});

export default withStyles(styles)(HomeContainer);
